<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" :funcClick="bindClickInterface"></ParseForm>
      </template>
    </div>
  </div>
</template>

<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "ModPviForm",
  components: {
    ParseForm,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      console.log(map);
      return map;
    },
     getJson(ne,checkedDatas, callback) {
      this.ne = ne;
      const checkedRecord = {
        ...checkedDatas[0],
      };
      console.log('checkedRecord',checkedRecord);
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.addpviJsonReq, params).then(response => {//假数据
      console.log("response",response)
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const jsonObj = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(jsonObj, checkedRecord);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        callback(response);
      }); 
    }, 
    saveUser(ne, callback) {
      const formData = this.getDatas();      
      if (formData) { 
        const params = { 
          vo: {
            "pvi": formData.get("pvi"),
            "ki": formData.get("ki"),
            "op": formData.get("op"),
            "amf": formData.get("amf"),
             }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      } 
    }, 
  },
  computed: {

  },
  data() {
    return {
      ne: null, 
      formItems: {
        basic: {
          formId: "PviModBasicInfo",
          modelName: "basic",
          formObj: null,
        },
      }, 
      opCode: "mod",
      msgId: "30472",
    };
  },
  beforeDestroy() {
  }
};
</script>
